import React, { Fragment, useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import SocialMapLogo from "./images/socialmap-logo.png";

import MultiStep from "./Wizard";

import Step0 from "./Steps/Step0";
import Step1 from "./Steps/Step1";
import Step2 from "./Steps/Step2";
import Step3 from "./Steps/Step3";
import Step4 from "./Steps/Step4";

import PageTitle from "../../Layout/AppMain/PageTitle";
import styles from "./index.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export const CsoSignUp = (props) => {
  const [disableAction, setDisableAction] = useState(false);
  const {
    open,
    setOpen,
    formState,
    setFormState,
    backToInitialPage,
    update = false,
    setFreezeModal,
  } = props;
  const steps = [
    {
      name: "",
      component: <Step0 update={update} setDisableAction={setDisableAction} />,
    },
    { name: "", component: <Step1 update={update} /> },
    { name: "", component: <Step2 update={update} /> },
    { name: "", component: <Step3 update={update} /> },
    {
      name: "",
      component: <Step4 update={update} setFreezeModal={setFreezeModal} />,
    },
  ];

  return (
    <Fragment>
      <span className="d-inline-block mb-2 mr-2">
        <Modal
          isOpen={open}
          backdrop={true}
          toggle={setOpen}
          size="xl"
          backdropClassName={styles["reverted-backdrop"]}
          className={styles["supporter-registration-modal"]}
        >
          <div
            style={{
              padding: "50px 50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={SocialMapLogo} alt="SocialMap Logo" />
            <div
              style={{
                fontSize: "20px",
                marginLeft: "12px",
              }}
            >
              {update ? "連携方針" : "サポーター登録"}
            </div>
          </div>
          <ModalBody>
            <div>
              <Row>
                <Col md="12" lg="12">
                  <MultiStep
                    showNavigation={true}
                    steps={steps}
                    formState={formState}
                    setFormState={setFormState}
                    showSkipButton={true}
                    disableAction={disableAction}
                    removePrevOnLastStep={true}
                    lastStepIcon={
                      <span>
                        <FontAwesomeIcon icon={faCheck} />
                      </span>
                    }
                  />
                </Col>
              </Row>
            </div>
          </ModalBody>
        </Modal>
      </span>
    </Fragment>
  );
};
